/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 *
 * @param {number} quantity - number of items to validate
 * @param {string} singularText - singular text
 * @param {string} pluralText - plural text
 * @returns {string} - singular or plural text
 */
export const getSingularOrPluralText = (
    quantity = 0,
    singularText = '',
    pluralText = ''
) => {
    if (
        typeof quantity === 'number' &&
        quantity > 1 &&
        typeof pluralText === 'string' &&
        !!pluralText
    ) {
        return pluralText;
    }

    return singularText || '';
};

export const vehicleTypeOptionsTimedEntry = [
    {
        label: 'Personal Vehicle',
        value: 'personal',
    },
    {
        label: 'Rental Vehicle',
        value: 'rental',
    },
];
